<template>
  <div class="mien_detail">
    <el-breadcrumb class="crumb" separator=">">
      <el-breadcrumb-item :to="{ path: '/mien/school' }"><span class="pointer" style="color: #A9ADB0">定向风采</span></el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/mien/school' }"><span class="pointer" style="color: #A9ADB0">学校风采</span></el-breadcrumb-item>
      <el-breadcrumb-item><span class="pointer" style="color: #76BF28">查看</span></el-breadcrumb-item>
    </el-breadcrumb>
    <div class="mien_detail_box">
      <div class="mien_detail_head">
        <el-image class="image" :src="detail.logo" fit="cover">
          <div slot="error" class="image_error">暂无图片</div>
        </el-image>
        <div>
          <h2>{{ detail.name }}</h2>
          <!--<h3>{{ detail.title }}</h3>-->
        </div>
      </div>
      <p class="ql-editor" v-html="detail.content"></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mienDetail',
  components: {},
  data () {
    return {
      detail: {}
    }
  },
  created () {
  },
  mounted () {
    this.loadDetail()
  },
  computed: {},
  methods: {
    loadDetail () {
      this.$axios.pDetail(this.$route.query.itemId).then(res => {
        if (res) {
          this.detail = res.data.data
        }
      })
    }
  },
  watch: {}
}
</script>

<style scoped>
  .mien_detail .crumb { margin-bottom: 20px; }
  .mien_detail .mien_detail_box { width: 100%; margin: 0 auto; border-radius: 2px; border: 1px solid #DCDFE6; }
  .mien_detail .mien_detail_head { border-radius: 2px; padding-bottom: 8px; }
  .mien_detail .mien_detail_head .image { width: 100%; margin-bottom: 20px; }
  .mien_detail .mien_detail_head .image img { width: 100%; }
  .mien_detail .mien_detail_head div h2 { font-size: 20px; font-weight: 600; color: #7FB842; line-height: 26px; text-align: center; }
  .mien_detail .mien_detail_head div h3 { font-size: 14px; font-weight: 600; color: #AFD289; line-height: 16px; text-align: center; }
  .mien_detail_text { color: #A9ADB0; font-size: 14px; text-indent: 2em; font-weight: 600; line-height: 20px; }
</style>



// WEBPACK FOOTER //
// src/pages/mien/detail/sDetail.vue